const SirTrevor = require('sir-trevor');

const acceptedTypes = {
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/pdf': 'pdf',
  'application/rtf': 'rtf',
  'application/zip': 'zip',
  'text/plain': 'txt'
};

const acceptedExtensionsArray = []
for (let mimeType in acceptedTypes) {
  acceptedExtensionsArray.push(acceptedTypes[mimeType])
}

function uploadOptions() {
  const html = `<div class="st-block__upload-accepted-types">Allowed file types: ${acceptedExtensionsArray.join(', ')}</div>
                <div class="st-block__upload-container">
                  <input type="file" type="st-file-upload">
                  <button class="st-upload-btn"><%= i18n.t("general:upload") %></button>
                </div>`
  return {html: html}
}

function extensionFromFilename(filename) {
  return filename.split('.').pop();
}

module.exports = (function(){

  return SirTrevor.Block.extend({

    type: "file",
    title: function() { return "File" },

    droppable: true,
    uploadable: true,

    icon_name: 'file',

    uploadUrl: '/attachments',

    loadData: function(data) {
      // Create our image tag
      this.renderFile(data.file);
    },

    renderFile: function(file) {
      let extension = file.mime_type ? acceptedTypes[file.mime_type] : extensionFromFilename(file.name);
      
      this.editor.innerHTML = `
        <div class="st-file">
          <div class="st-file__icon">
            <div class="st-file__icon-label">${extension}</div>
          </div>
          <div class="st-file__meta">
            <div class="st-file__heading">Uploaded file</div>
            <div class="st-file__name">${file.name}</div>
          </div>
        </div>
      `;
    },

    upload_options: uploadOptions(),

    isAcceptedFileType: function(file) {
      // In windows type will be empty for some files, so rely on extension.
      if (file.type === "") {
        return acceptedExtensionsArray.indexOf(extensionFromFilename(file.name)) > -1;
      }
      return Object.keys(acceptedTypes).indexOf(file.type) > -1;
    },

    onDrop: function(transferData) {
      var file = transferData.files[0],
          urlAPI = (typeof URL !== "undefined") ? URL : (typeof webkitURL !== "undefined") ? webkitURL : null;
      
      if (this.isAcceptedFileType(file)) {
        this.loading();
        // Show this image on here
        this.inputs.style.display = 'none';
        this.renderFile({
          name: file.name
        });
        this.editor.style.display = '';

        this.uploader(
          file,
          function(data) {
            this.setData(data);
            this.ready();
          },
          function(error) {
            this.addMessage(i18n.t('blocks:image:upload_error'));
            this.ready();
          }
        );
      } else {
        this.addMessage(i18n.t('blocks:image:upload_error'));
      }
    }
  })
})();
